var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrevious(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "btn/icon/32x32-previous"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/previous"
  }, /*#__PURE__*/React.createElement("g", {
    id: "previous"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2409 7.22022C19.2409 6.0243 17.9477 5.27861 16.9104 5.87658L8.61037 10.6666C7.57779 11.2618 7.57779 12.7486 8.61037 13.3439L8.61156 13.3445L12.76 15.7436L16.91 18.1337C17.9444 18.7299 19.2409 17.9795 19.2409 16.7902V7.22022ZM15.9119 4.14366C18.2745 2.78202 21.2409 4.47628 21.2409 7.22022V16.7902C21.2409 19.521 18.2771 21.2303 15.9115 19.8666L11.7603 17.4759L7.61151 15.0766L8.11094 14.2102L7.61032 15.0759C5.24423 13.7108 5.24448 10.2988 7.61106 8.93411L15.9119 4.14366Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.76172 4.82031C4.314 4.82031 4.76172 5.26803 4.76172 5.82031V18.1803C4.76172 18.7326 4.314 19.1803 3.76172 19.1803C3.20943 19.1803 2.76172 18.7326 2.76172 18.1803V5.82031C2.76172 5.26803 3.20943 4.82031 3.76172 4.82031Z",
    fill: "currentColor"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrevious);
export default __webpack_public_path__ + "static/media/previous.145bdeb1a691edfc605bbe01e1dc39ec.svg";
export { ForwardRef as ReactComponent };